require('masonry-layout/masonry')
// require('@/assets/js/imagesloaded.pkgd.min')